const comparisonModule = document.querySelector('.comparison-module');

if (comparisonModule) {
  const getSearchEls = () => comparisonModule.querySelectorAll('.comparison-item__search');

  comparisonModule
    .querySelectorAll('.comparison-item__search-button, .comparison-item__placeholder-block')
    .forEach((button) =>
      button.addEventListener('click', (e) => {
        e.stopPropagation();
        const item = button.closest('.comparison-item');
        item?.querySelector('.comparison-item__search').classList.add('is-active');
        item?.querySelector('.comparison-item__search-input input')?.focus();
      }),
    );

  comparisonModule.addEventListener('click', (e) => {
    const inputWrap = e.target.closest('.comparison-item__search-input');
    if (inputWrap) {
      inputWrap.querySelector('input')?.focus();
    }
  });

  const closeDropdowns = (e) =>
    getSearchEls().forEach((search) => {
      if (!search.contains(e.target)) search.classList.remove('is-active');
    });

  comparisonModule.addEventListener('click', (e) => {
    const productCard = e.target.closest('.comparison-item__search-dropdown__product-btn');
    if (!productCard) return;

    const item = productCard.closest('.comparison-item');
    const placeholder = item?.querySelector('.comparison-item__placeholder');
    const wrap = productCard.closest('.comparison-item__search-dropdown__product-wrap');
    const productCardWrap = wrap?.querySelector('.comparison-item__to-copy');

    item.classList.add('has-product');
    item.querySelectorAll('.comparison-item__selected-product').forEach((el) => el.remove());

    const el = document.createElement('div');
    el.className = 'comparison-item__selected-product';
    el.innerHTML = productCardWrap.innerHTML;

    placeholder.after(el);
    item.querySelector('.comparison-item__search')?.classList.remove('is-active');
  });

  document.addEventListener('click', closeDropdowns);

  comparisonModule.querySelectorAll('.comparison-item__search-input input').forEach((input) => {
    const item = input.closest('.comparison-item');
    if (!item) return;

    const wraps = [...item.querySelectorAll('.comparison-item__search-dropdown__product-wrap')];
    const empty = item.querySelector('.comparison-item__search-dropdown__empty');

    input.addEventListener('input', ({ target }) => {
      const value = target.value.trim().toLowerCase();
      let visibleCount = 0;

      wraps.forEach((wrap) => {
        const title = wrap.querySelector('.product-card__title')?.textContent?.toLowerCase() || '';
        const visible = title.includes(value);

        wrap.style.display = visible ? '' : 'none';
        visibleCount += visible;
      });

      if (empty) {
        empty.style.display = visibleCount ? 'none' : '';
      }
    });
  });

  const activeProductId = new URLSearchParams(location.search).get('product_id')?.split(',')[0]?.trim();

  if (activeProductId) {
    comparisonModule
      .querySelector(
        `.comparison-item:first-child .comparison-item__search-dropdown__product-wrap[data-product-id="${activeProductId}"] .comparison-item__search-dropdown__product-btn`,
      )
      ?.click();
  }
}
